import React from "react";
import PropTypes from "prop-types";
import { FluentDialog2 } from "../../../FluentUI/Fluent-Dialog2";
import { FluentInput } from "../../../FluentUI/Fluent-Input";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import "./task-object-viewer.scss";
import Empty from "../../../../assets/icons/Illustration - Missing content.svg";

export const TaskObjectViewer = ({ open, OnCancel, Value, ColumnName }) => {
  let convertedValue;

  if (typeof Value === "string") {
    try {
      convertedValue = JSON.parse(Value);
    } catch (e) {
      console.error("Error parsing JSON string:", e);
    }
  }

  return (
    <FluentDialog2 open={open}>
      <div className="task-type-dialog-title">
        <p>{ColumnName}</p>
        <p onClick={OnCancel}>
          <FluentUiIcon name={"DismissRegular"} color={"#212121"} size={20} />
        </p>
      </div>
      <div className="task-type-dialog-content">
        {convertedValue && Object.keys(convertedValue).length !== 0 ? (
          Object.entries(convertedValue).map(([key, value]) => (
            <div className="object-row" key={key}>
              <FluentInput
                label={key}
                defaultValue={value}
                disabled={true}
              ></FluentInput>
            </div>
          ))
        ) : (
          <div className="d-flex flex-column justify-content-center align-items-center my-5 empty">
            <img
              className="empty-picture"
              src={Empty}
              alt={"nothing to see here"}
            />
            <div className="empty-text">Nothing to see here</div>
            <div className="empty-text2">
              No additional details are available for this item at the moment.
            </div>
          </div>
        )}
      </div>
    </FluentDialog2>
  );
};

TaskObjectViewer.propTypes = {
  open: PropTypes.bool.isRequired,
  Value: PropTypes.object.isRequired,
  OnCancel: PropTypes.func.isRequired,
  ColumnName: PropTypes.string.isRequired,
};
